<template>
  <div class="solution-detail-container">
    <!-- 主标题 -->
    <div class="main-title">
      <h1>解决方案详情</h1>
      <div class="title-divider"></div>
    </div>

    <!-- 加载状态 -->
    <div v-if="loading" class="loading-container">
      <el-skeleton :rows="6" animated />
    </div>

    <!-- 内容展示 -->
    <div v-else class="solution-content">
      <!-- 方案标题区 -->
      <div class="solution-header">
        <h2 class="solution-title">{{ solutionData.title }}</h2>
        <div class="solution-subtitle">{{ solutionData.subtitle }}</div>
        <div class="solution-meta">
          <el-tag type="info" size="small" class="meta-tag">
            <el-icon><el-icon-clock /></el-icon>
            更新于 {{ formatDate(solutionData.time) }}
          </el-tag>
        </div>
      </div>

      <!-- 方案概览卡片 -->
      <el-card class="solution-overview" shadow="hover">
        <div class="overview-content">
          <div class="overview-text-container">
            <h1 class="overview-name" v-html="solutionData.name"></h1>
            <div class="overview-text" v-html="solutionData.text"></div>
          </div>
          <div class="overview-image-container">
            <el-image
                class="overview-image"
                :src="solutionData.imgUrl"
                :preview-src-list="[solutionData.imgUrl]"
                fit="contain"
                lazy
            >
              <template #error>
                <div class="image-error">
                  <el-icon :size="40"><el-icon-picture /></el-icon>
                  <span>封面图片加载失败</span>
                </div>
              </template>
              <template #placeholder>
                <div class="image-loading">
                  <el-icon class="is-loading" :size="40"><el-icon-loading /></el-icon>
                </div>
              </template>
            </el-image>
          </div>
        </div>
      </el-card>

      <!-- 方案详细介绍 -->
      <div class="solution-sections">
        <!-- 方案背景部分 -->
        <div class="section">
          <div class="section-header">
            <h3 class="section-title">
              <el-icon class="title-icon"><el-icon-info /></el-icon>
              方案介绍
            </h3>
          </div>
          <div class="section-content" v-html="solutionData.background || solutionData.content"></div>

          <div v-if="solutionData.introduce" class="section-images">
            <div class="full-width-image-container">
              <el-image
                  :src="solutionData.introduce"
                  :preview-src-list="[solutionData.introduce]"
                  fit="contain"
                  class="full-width-image"
                  lazy
              >
                <template #placeholder>
                  <div class="image-loading">
                    <el-icon class="is-loading"><el-icon-loading /></el-icon>
                  </div>
                </template>
                <template #error>
                  <div class="image-error">
                    <el-icon><el-icon-picture /></el-icon>
                  </div>
                </template>
              </el-image>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Document,
  Clock as ElIconClock,
  Picture as ElIconPicture,
  Loading as ElIconLoading,
  Info as ElIconInfo
} from '@element-plus/icons-vue'
import serverApi from "@/api/server";

export default {
  components: {
    Document,
    ElIconClock,
    ElIconPicture,
    ElIconLoading,
    ElIconInfo
  },
  data() {
    return {
      loading: false,
      solutionData: {
        title: "打造专业、高效、安全的解决方案",
        name: "智能仓储管理系统",
        text: "<p>本方案通过物联网、大数据和人工智能技术，实现仓储管理的全面数字化和智能化转型，帮助企业提升仓储效率40%以上，降低运营成本30%。</p>",
        time: "2023-10-15",
        imgUrl: "http://132.232.203.173:9005/glfwz/2025_07_07/e4f61560-6e3c-431f-9739-2562e915a509/1.png",
        background: "<p>我们的智能仓储解决方案提供全面的管理功能，包括智能库存管理、自动化调度、数据分析和多终端支持。</p>",
        introduce: "http://132.232.203.173:9005/glfwz/2025_07_07/e4f61560-6e3c-431f-9739-2562e915a509/1.png"
      }
    }
  },
  created() {
    this.CaseShow(this.$route.query.id)
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '未知日期'
      const date = new Date(dateString)
      return date.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
    },
    CaseShow(solutionDataId) {
      this.loading = true;
      serverApi.CaseShow(solutionDataId)
          .then(res => {
            this.solutionData = {
              ...this.solutionData, // 默认数据
              ...res.data.data      // API返回数据
            };
          })
          .catch(error => {
            console.error("获取方案详情失败:", error);
            this.$message.error("加载方案详情失败");
          })
          .finally(() => {
            this.loading = false;
          });
    }
  }
}
</script>

<style scoped lang="scss">
.solution-detail-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  color: var(--el-text-color-primary);
  font-family: 'Helvetica Neue', Arial, sans-serif;
}

/* 主标题样式 */
.main-title {
  text-align: center;
  margin-bottom: 40px;

  h1 {
    font-size: 2.2rem;
    font-weight: 600;
    color: var(--el-color-primary);
    margin-bottom: 10px;
    position: relative;
    display: inline-block;
    padding-bottom: 15px;

    @media (min-width: 768px) {
      font-size: 2.8rem;
    }
  }

  .title-divider {
    width: 80px;
    height: 3px;
    background: linear-gradient(90deg, var(--el-color-primary), var(--el-color-primary-light-3));
    margin: 0 auto;
    border-radius: 3px;
  }
}

/* 加载状态 */
.loading-container {
  padding: 40px;
  background: var(--el-fill-color-lighter);
  border-radius: 8px;
}

/* 方案标题区 */
.solution-header {
  text-align: center;
  margin-bottom: 40px;

  .solution-title {
    font-size: 1.8rem;
    font-weight: 600;
    margin-bottom: 15px;
    color: var(--el-text-color-primary);
    line-height: 1.3;

    @media (min-width: 768px) {
      font-size: 2.2rem;
    }
  }

  .solution-subtitle {
    font-size: 1.1rem;
    color: var(--el-text-color-regular);
    margin-bottom: 20px;
    line-height: 1.6;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;

    @media (min-width: 768px) {
      font-size: 1.2rem;
    }
  }

  .solution-meta {
    margin-top: 20px;

    .meta-tag {
      padding: 8px 12px;
      border-radius: 16px;

      .el-icon {
        margin-right: 5px;
      }
    }
  }
}

/* 方案概览卡片 */
.solution-overview {
  margin-bottom: 40px;
  border-radius: 12px;
  border: none;
  overflow: hidden;

  :deep(.el-card__body) {
    padding: 0;
  }

  .overview-content {
    display: flex;
    flex-direction: column;

    @media (min-width: 992px) {
      flex-direction: row;
    }

    .overview-text-container {
      flex: 1;
      padding: 30px;

      @media (min-width: 768px) {
        padding: 40px;
      }

      .overview-name {
        font-size: 1.6rem;
        font-weight: 600;
        margin-bottom: 20px;
        color: var(--el-text-color-primary);
        line-height: 1.4;

        @media (min-width: 768px) {
          font-size: 1.8rem;
        }
      }

      .overview-text {
        font-size: 1.05rem;
        line-height: 1.8;
        color: var(--el-text-color-regular);

        :deep(p) {
          margin-bottom: 1.2em;
        }

        :deep(ul) {
          margin: 1.2em 0;
          padding-left: 1.5em;

          li {
            margin-bottom: 0.8em;
            position: relative;

            &::before {
              content: "•";
              color: var(--el-color-primary);
              font-weight: bold;
              display: inline-block;
              width: 1em;
              margin-left: -1em;
            }
          }
        }
      }
    }

    .overview-image-container {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px;
      background: var(--el-fill-color-light);

      @media (min-width: 992px) {
        width: 50%;
        min-height: 400px;
      }

      .overview-image {
        max-width: 100%;
        height: auto;
        max-height: 400px;
        border-radius: 8px;
        object-fit: contain;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        transition: transform 0.3s ease;

        &:hover {
          transform: scale(1.02);
        }
      }
    }
  }
}

/* 方案详细介绍 */
.solution-sections {
  margin-bottom: 50px;

  .section {
    margin-bottom: 50px;

    .section-header {
      margin-bottom: 25px;

      .section-title {
        font-size: 1.5rem;
        font-weight: 600;
        margin-bottom: 0;
        display: inline-flex;
        align-items: center;
        line-height: 1.4;
        padding-bottom: 10px;
        border-bottom: 4px solid var(--el-color-primary);

        .title-icon {
          margin-right: 12px;
          color: var(--el-color-primary);
        }
      }
    }

    .section-content {
      font-size: 1.05rem;
      line-height: 1.8;
      color: var(--el-text-color-regular);
      margin-bottom: 25px;

      :deep(p) {
        margin-bottom: 1.2em;
      }

      :deep(ul) {
        margin: 1.5em 0;
        padding-left: 1.8em;

        li {
          margin-bottom: 0.8em;
          position: relative;

          &::before {
            content: "•";
            color: var(--el-color-primary);
            font-weight: bold;
            display: inline-block;
            width: 1em;
            margin-left: -1em;
          }
        }
      }

      :deep(strong) {
        color: var(--el-text-color-primary);
      }
    }

    .section-images {
      margin-top: 30px;

      .full-width-image-container {
        width: 100%;
        background: var(--el-fill-color-light);
        border-radius: 8px;
        padding: 20px;
        box-sizing: border-box;

        .full-width-image {
          width: 100%;
          height: auto;
          max-height: 1080px;
          object-fit: contain;
          border-radius: 4px;
          display: block;
          margin: 0 auto;
        }
      }
    }
  }
}

/* 图片加载状态 */
.image-loading, .image-error {
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: var(--el-fill-color-light);
  color: var(--el-text-color-placeholder);
  border-radius: 8px;

  .el-icon {
    font-size: 40px;
    margin-bottom: 10px;
  }
}
</style>
